import Swiper, { Navigation, Autoplay } from 'swiper';

import 'swiper/css/bundle';

const swiper = new Swiper('.related-slider', {
    modules: [Navigation, Autoplay],
    loop: true,
    speed: 1000,
    spaceBetween: 32,
    slidesPerView: 1,
    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
    },
    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.rel-swiper-next-btn',
        prevEl: '.rel-swiper-prev-btn',
    },
});


document.addEventListener('DOMContentLoaded', () => {
    const toc = document.getElementById('toc');
    const headings = document.querySelectorAll('.Content--post h2, .Content--post h3, .Content--post h4');

    headings.forEach((h, i) => {
        h.id = h.id || `heading-${i}`;
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent;

        a.className = {
            'H2': 'font-medium text-gray600 hover:text-primary',
            'H3': 'font-medium text-gray600 hover:text-primary',
            'H4': 'font-medium text-gray600 hover:text-primary',
        }[h.tagName];

        toc.appendChild(a);
    });
});